import { api } from './base-api';
import {
  AjusteAntecipacao,
  MoedaAjuste,
  UpsertAjusteAntecipacaoPayload,
} from '../../types/ajuste-antecipacao';

export const ajusteAntecipacaoApi = {
  async listByCliente(clienteId: string): Promise<AjusteAntecipacao[]> {
    const { data } = await api.get<AjusteAntecipacao[]>(
      `/admin/clientes/${clienteId}/ajustes-antecipacao`,
    );
    return data;
  },

  async upsert(
    clienteId: string,
    moeda: MoedaAjuste,
    payload: UpsertAjusteAntecipacaoPayload,
  ): Promise<AjusteAntecipacao> {
    const { data } = await api.put<AjusteAntecipacao>(
      `/admin/clientes/${clienteId}/ajustes-antecipacao/${moeda}`,
      payload,
    );
    return data;
  },

  async remove(clienteId: string, moeda: MoedaAjuste): Promise<void> {
    await api.delete(
      `/admin/clientes/${clienteId}/ajustes-antecipacao/${moeda}`,
    );
  },
};
